declare let iNet: any;
declare let $: any;

export class SubFirmDictionary {

  create(data: DictionaryData, callback: Function) {
    $.ajax({
      type: 'post',
      url: this.getUrl('subfirm/dictionary/create'),
      data: data,
      success: (data: any) => callback(data),
      error: () => callback(null)
    });
  }

  update(data: DictionaryData, callback: Function) {
    data.dictID = data.dictID || data.uuid;
    $.ajax({
      type: 'post',
      url: this.getUrl('subfirm/dictionary/update'),
      data: data,
      success: (data: any) => callback(data),
      error: () => callback(null)
    });
  }

  remove(data: DictionaryData, callback: Function) {
    data.dictID = data.dictID || data.uuid;
    $.ajax({
      url: this.getUrl('subfirm/dictionary/remove'),
      data: data,
      success: (data: any) => callback(data),
      error: () => callback(null)
    });
  }

  list(reference: string, callback: Function) {
    $.ajax({
      url: this.getUrl('subfirm/dictionary/list'),
      data: {
        reference: reference
      },
      success: (data: any) => callback(data && data.items || []),
      error: () => callback([])
    });
  }


  getUrl(url: string): string {
    return iNet.getPUrl(url);
  }

}

export interface DictionaryData {
  dictID?: string // uuid when update
  name?: string
  value?: string
  reference?: string
  uuid?: string
  cache?: boolean
  order?: number
}
